/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ColumnMetadata } from './columnMetadata';


export interface TimeSeriesData { 
    columns?: Array<ColumnMetadata>;
    records?: Array<{ [key: string]: object; }>;
}

